import { Row, Col } from 'antd'
import _ from 'lodash'
import { PROPOSAL_EXECUTE_STATUS, PROPOSAL_EXECUTE_STATUS_MAP } from '@vzmi/shp_shared_compo/dist/constants/proposal.js'
import { convertDateByMoment } from '@vzmi/component_ec_nodejs_util/dist/lib/renderUtil'
import { useQueryString } from '@vzmi/shp_shared_compo/dist/hook/useQueryString.js'
import { ExecuteStatusIcon, ExecuteTime } from '../../../Proposal/Common/ProposalStatusBar/ProposalStatusBar'
import { EMPTY_VALUE } from '../../../../constants/globalTypes'
import styles from './index.css'
import { ProposalBlock, ProposalSection } from '@vzmi/shp_shared_compo'
import { AntdCheckbox } from '../../../Common/Form'

const PROPOSAL_TS_TYPE = {
  INSTANT_EXECUTE: 'instantExecute',
  NON_INSTANT_EXECUTE: 'nonInstantExecute',
  REVERT: 'revert'
}

const PROPOSAL_TS_TYPE_MAP = {
  [PROPOSAL_TS_TYPE.INSTANT_EXECUTE]: '預約修改圖片提案執行時間',
  [PROPOSAL_TS_TYPE.NON_INSTANT_EXECUTE]: '修改圖片提案執行時間',
  [PROPOSAL_TS_TYPE.REVERT]: '設定自動回檔'
}

const getProposalTsType = (batchProposal = {}, proposalBatchType) => {
  if (_.isEmpty(batchProposal)) {
    return ''
  }

  const { instantExecute } = batchProposal
  const isRevert = proposalBatchType === 'revert'
  let proposalTsType
  switch (true) {
    case isRevert: {
      proposalTsType = PROPOSAL_TS_TYPE.REVERT
      break
    }
    case (!instantExecute): {
      proposalTsType = PROPOSAL_TS_TYPE.INSTANT_EXECUTE
      break
    }
    case instantExecute: {
      proposalTsType = PROPOSAL_TS_TYPE.NON_INSTANT_EXECUTE
      break
    }
    default: {
      break
    }
  }
  return proposalTsType
}

const getProposalTsByTsType = (batchProposal = {}, proposalTsType) => {
  if (_.isEmpty(batchProposal)) {
    return ''
  }

  const { executeTs, revertTs } = batchProposal
  let proposalTs
  switch (proposalTsType) {
    case PROPOSAL_TS_TYPE.INSTANT_EXECUTE:
    case PROPOSAL_TS_TYPE.NON_INSTANT_EXECUTE: {
      proposalTs = executeTs
      break
    }
    case PROPOSAL_TS_TYPE.REVERT: {
      proposalTs = revertTs
      break
    }
    default: {
      break
    }
  }
  return proposalTs
}

const getProposalStatusByTsType = (batchProposal = {}, proposalTsType) => {
  if (_.isEmpty(batchProposal)) {
    return ''
  }

  const { executeStatus, revertStatus } = batchProposal
  let proposalStatus
  switch (proposalTsType) {
    case PROPOSAL_TS_TYPE.INSTANT_EXECUTE:
    case PROPOSAL_TS_TYPE.NON_INSTANT_EXECUTE: {
      proposalStatus = executeStatus
      break
    }
    case PROPOSAL_TS_TYPE.REVERT: {
      proposalStatus = revertStatus
      break
    }
    default: {
      break
    }
  }
  return proposalStatus
}

const ScheduledStatus = (props) => {
  const {
    proposals = [],
    batch = {},
    batchResult = {}
  } = props
  const proposalBatchType = useQueryString(global.window, 'type', false)
  const proposalTsType = getProposalTsType(batch, proposalBatchType)
  const proposalTsTypeText = _.get(PROPOSAL_TS_TYPE_MAP, proposalTsType, EMPTY_VALUE)
  const proposalTs = getProposalTsByTsType(batch, proposalTsType)
  const proposalStatus = getProposalStatusByTsType(batch, proposalTsType)
  const isWithCheckbox = [PROPOSAL_TS_TYPE.INSTANT_EXECUTE, PROPOSAL_TS_TYPE.REVERT].includes(proposalTsType)
  const isRevertFinish = _.get(batch, 'revertStatus') === PROPOSAL_EXECUTE_STATUS.FINISHED
  const revertFinishTs = _.get(proposals, '0.modifiedTs')
  const successProposalCount = _.size(_.get(batchResult, 'successProposalMap', {}))
  const failedProposalCount = _.size(_.get(batchResult, 'failedProposalMap', {}))

  return (
    <ProposalSection>
      <ProposalBlock>
        <Row
          type='flex'
          align='middle'
          justify='space-between'
        >
          <Col span={6}>
            {isWithCheckbox && (
              <AntdCheckbox
                className={styles.checkbox}
                checked
                readOnly
              >
                {proposalTsTypeText}
              </AntdCheckbox>
            )}
            {!isWithCheckbox && proposalTsTypeText}
          </Col>
          <Col span={18}>
            執行狀態
          </Col>
          <Col span={6}>
            <span className={styles.batchTime}>
              {!proposalTs && EMPTY_VALUE}
              {proposalTs && convertDateByMoment(proposalTs, 'YYYY-MM-DD HH:mm')}
            </span>
          </Col>
          <Col
            span={18}
            className={styles.executeStatus}
          >
            {!proposalStatus && EMPTY_VALUE}
            {proposalStatus && (
              <>
                <p>
                  <ExecuteStatusIcon executeStatus={proposalStatus} />
                  {PROPOSAL_EXECUTE_STATUS_MAP[proposalStatus]}
                  {proposalStatus === PROPOSAL_EXECUTE_STATUS.FINISHED && (
                    `(共${successProposalCount + failedProposalCount}筆，成功${successProposalCount}筆、失敗${failedProposalCount}筆)`
                  )}
                </p>
                {isRevertFinish && (
                  <p>
                    {!revertFinishTs && EMPTY_VALUE}
                    {revertFinishTs && (
                      <ExecuteTime
                        executedTime={convertDateByMoment(revertFinishTs, 'YYYY-MM-DD HH:mm:ss')}
                      />
                    )}
                  </p>
                )}
              </>
            )}
          </Col>
        </Row>
      </ProposalBlock>
    </ProposalSection>
  )
}

export default ScheduledStatus
